import { render, staticRenderFns } from "./PlatformOrganizationList.vue?vue&type=template&id=36feff88&scoped=true"
import script from "./PlatformOrganizationList.vue?vue&type=script&lang=js"
export * from "./PlatformOrganizationList.vue?vue&type=script&lang=js"
import style0 from "./PlatformOrganizationList.vue?vue&type=style&index=0&id=36feff88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36feff88",
  null
  
)

export default component.exports